export default __webpack_public_path__ + "static/media/datis.f38da1d2.svg";